import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import type { DSSetup } from 'webapp-types';
import { sanitize } from 'webapp/utils/html';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type { FilterItem } from 'webapp/models-custom';

interface Args {
	model: FilterItem;
	logicalOperatorText?: string;
	metricDimensions: DSSetup.DimensionItem[];
	edit: () => void;
	remove: () => void;
}

export default class BlockFiltersListItemComponent extends Component<Args> {
	get dimensionName() {
		const dimension = this.args.model.field;
		const dimensionName =
			this.args.metricDimensions.find((d) => d.key === dimension)?.value || dimension;
		return sanitize(dimensionName);
	}

	get textStart() {
		let text = '';
		if (this.args.logicalOperatorText) {
			text += `${this.args.logicalOperatorText} `;
		}
		text += `${this.dimensionName}: ${this.args.model.operatorText} `;
		return text;
	}

	get textEnd() {
		return this.args.model.values.map((value) => sanitize(value)).join(', ');
	}

	<template>
		<div class="ms-filters-item">
			<div class="text">
				{{this.textStart}}
				<strong>{{this.textEnd}}</strong>
			</div>
			<div class="actions">
				<a {{on "click" @edit}}><CommonUiIconComponent @name="Pencil" @size="sm" /></a>
				<a {{on "click" @remove}}><CommonUiIconComponent @name="Trash" @size="sm" /></a>
			</div>
		</div>
	</template>
}
